export const messages = {
    en: {
        common: {
            title: 'Participants',
            timeline: 'Timeline',
            noContent: "No content has been released yet",
            overview: "Overview",
            content: "Content",
            channels: "Channels",
            contentArea: "Content area",
            contentGuide: "Click on content to the left to display it here",
            systemStatus: "System is {status}",

        },
        gameStart: {
            appointTeam: "Please appoint a crisis management team",
            appointRoles: "Appoint roles here",
            soon: "Game starts soon"
        },
        communication: {
            account: "Account",
            name: "Name",
            noNewTweets: "No new tweets",
            noNewFb: "No new posts",
            noNewEmails: "No new emails",
            generatedUser: "Generated user",
            replying: "Replying",
            receiver: "Receiver",
            for: "For",
            sender: "Sender",
            placeholder: "Type your reply here"
        }
    },
    da: {
        common: {
            title: 'Deltagere',
            timeline: 'Tidslinje',
            noContent: "Der er ikke blevet frigivet noget indhold endnu",
            overview: "Oversigt",
            content: "Indhold",
            channels: "Kanaler",
            contentArea: "Indholdsområde",
            contentGuide: "Klik på indhold til venstre for at vise det her",
            systemStatus: "Systemet er {status}",
        },
        gameStart: {
            appointTeam: "I bedes konstituere en kriseledelse",
            appointRoles: "Tildel roller herunder",
            soon: "Spillet starter om lidt"

        },
        communication: {
            account: "Konto",
            noNewTweets: "Ingen nye tweets",
            noNewFb: "Ingen nye opslag",
            noNewEmails: "Ingen nye emails",
            generatedUser: "Genereret bruger",
            name: "Navn",
            replying: "Svarer",
            receiver: "Modtager",
            for: "Til",
            sender: "Afsender",
            placeholder: "Skriv dit svar her"


        }
    }
}